import { styled } from '@mui/material/styles';
import { 
  Button, 
  InputBase, 
  Popover,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  ListItemButton,
} from '@mui/material';

export const SearchContainer = styled('div')(({ theme }) => ({
  maxWidth: '1496px',
  margin: '0 auto',
  padding: '36px',
  backgroundColor: '#FEF1EA',
  borderRadius: '10px',

  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  backgroundColor: '#ffffff',
  borderRadius: '25px',
  height: '40px',
  minWidth: '150px',
  border: '1px solid #D3D3D3',
  '& .MuiSelect-select': {
    paddingLeft: theme.spacing(2),
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiSvgIcon-root': {
    color: '#D3D3D3',
  },
  '&:hover .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #F4762A',
  },
  '& .MuiPaper-root': {
    borderRadius: '10px',
    marginTop: '8px',
    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
    padding: '32px',
  },
  '& .MuiList-root': {
    padding: 0,
  },
  '& .MuiMenuItem-root': {
    padding: '12px 16px',
    borderBottom: '1px solid #E0E0E0',
    '&:last-child': {
      borderBottom: 'none',
    },
    '&:hover': {
      backgroundColor: '#F5F5F5',
    },
  },
}));

export const SearchInput = styled(InputBase)(({ theme }) => ({
  backgroundColor: '#ffffff',
  borderRadius: '25px',
  border: '1px solid #D3D3D3',
  padding: theme.spacing(0.5, 2),
  flex: 1,
  height: '40px',
  '&::placeholder': {
    color: '#919192',
    opacity: 1,
  },
  '&:hover, &.Mui-focused': {
    border: '1px solid #F4762A',
  },
}));

export const FilterPopover = styled(Popover)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '20px',
    boxShadow: 'none',
    width: '100%',
    maxWidth: '752px',
    margin: '8px 0',
    overflow: 'hidden',
    padding: '0px 12px',
  },
  '& ::-webkit-scrollbar': {
    width: '8px',
  },
  '& ::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '10px',
    border: '2px solid transparent',
  },
  '& ::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '10px',
  },
  '& ::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
}));

export const FilterAccordion = styled(Accordion)(({ theme }) => ({
  boxShadow: 'none',
  '&:before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: 0,
  },
}));

export const FilterAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  padding: '12px 0px',
  '& .MuiAccordionSummary-content': {
    margin: 0,
  },
  '&.Mui-expanded': {
    minHeight: '48px',
  },
}));

export const FilterAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: '0 16px 16px',
  maxHeight: '270px',
  overflowY: 'auto',
}));

export const FilterButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#ffffff',
  borderRadius: '25px',
  padding: theme.spacing(0.5, 2),
  boxShadow: 'none',  
  textTransform: 'none',
  minWidth: '259px',
  height: '40px',
  textAlign: 'left',
  justifyContent: 'flex-start',
  '& .MuiButton-startIcon': {
    marginRight: theme.spacing(1),
  },
  '&:hover': {
    backgroundColor: '#f5f5f5',
    border: '1px solid #F4762A',
    boxShadow: 'none',
  },
}));

export const ActionButtonPrimary = styled(Button)(({ theme }) => ({
  borderRadius: '25px',
  padding: theme.spacing(1, 3),
  textTransform: 'none',
  margin: theme.spacing(0, 0.5),
  minWidth: '120px',
}));

export const SearchButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#F4762A',
  color: '#ffffff',
  borderRadius: '25px',
  padding: theme.spacing(0.5, 3),
  boxShadow: 'none',
  textTransform: 'none',
  height: '40px',
  '&:hover': {
    backgroundColor: '#e06521',
    boxShadow: 'none',
  },
}));

export const ActionButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '16px',
  position: 'sticky',
  bottom: 0,
  backgroundColor: '#fff',
  zIndex: 10,
}));

export const PriceButton = styled(Button)(({ theme }) => ({
  borderRadius: '10px',
  padding: '12px',
  textTransform: 'none',
  color: '#575758',
  backgroundColor: '#ffffff',
  fontSize: '16px',
  fontWeight: 400,
  fontFamily: 'Prompt, sans-serif',
  width: '100%',
  height: 'auto',
  display: 'flex',
  justifyContent: 'flex-start',
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  width: '332px',
  height: '43px',
  borderRadius: '40px',
  gap: '8px',
  padding: '12px 24px',
  border: '1px solid #D3D3D3',
  background: '#FFFFFF',
  fontFamily: 'Prompt, sans-serif',
  fontSize: '16px',
  fontWeight: 400,
  '&:hover, &.Mui-focused': {
    border: '1px solid #F4762A',
  },
}));

export const LocationPopover = styled(Popover)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '20px',
    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
    width: '100%',
    maxWidth: '752px',
    margin: '8px 0',
    overflow: 'hidden',
    padding: '0px 12px',
  },
  '& ::-webkit-scrollbar': {
    width: '8px',
  },
  '& ::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '10px',
    border: '2px solid transparent',
  },
  '& ::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '10px',
  },
  '& ::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
}));

export const LocationButton = styled(Button)(({ theme }) => ({
  width: '100%',
  justifyContent: 'space-between',
  padding: '10px 16px',
  textAlign: 'left',
  textTransform: 'none',
  borderRadius: '0',
  color: '#000',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
  borderBottom: '1px solid #EEEEEE',
}));

export const LocationListItem = styled(ListItemButton)(({ theme }) => ({
  padding: '12px 16px',
  borderRadius: '0px',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
  borderBottom: '1px solid #EEEEEE',
  margin: '0',
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const ScrollableBox = styled(Box)(({ theme }) => ({
  maxHeight: '450px',
  overflowY: 'auto',
  padding: '0',
  width: '100%',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
}));

// สไตล์สำหรับ Modal ค้นหาที่ตั้ง
export const ModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '635px',
  maxHeight: '600px',
  bgcolor: 'background.paper',
  borderRadius: '10px',
  boxShadow: 24,
  p: 0,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
};

export const ModalHeader = styled(Box)(({ theme }) => ({
  backgroundColor: '#F4762A',
  padding: '16px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: 'white',
  minHeight: '64px',
}));

export const ModalSearchInput = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    height: '42px',
    borderRadius: '25px',
    backgroundColor: 'white',
    '& fieldset': {
      borderColor: '#e0e0e0',
    },
    '&:hover fieldset': {
      borderColor: '#F4762A',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#F4762A',
    },
    '& .MuiInputAdornment-root': {
      marginLeft: '8px',
    },
  },
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: '25px',
  padding: theme.spacing(1, 3),
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
  },
}));

import { Select, MenuItem } from '@mui/material'; 